import React from "react";
import { Card, Select, InputNumber, Typography, Row, Col } from "antd";

const { Text } = Typography;
const { Option } = Select;

const ControlsCard = ({
  expirations,
  selectedExpiration,
  setSelectedExpiration,
  expectedMove,
  setExpectedMove,
  expectedDays,
  setExpectedDays,
  currentExpirationData,
  currentIV,
  futureIV,
  setFutureIV,
}) => {
  return (
    <Card style={{ marginBottom: 24 }}>
      <Row gutter={[16, 16]}>
        <Col xs={24} sm={12} md={6}>
          <Text strong>Expiration Date:</Text>
          <Select
            style={{ width: "100%", marginTop: 8 }}
            value={selectedExpiration}
            onChange={setSelectedExpiration}
          >
            {expirations.map((exp) => (
              <Option key={exp} value={exp}>
                {exp}
              </Option>
            ))}
          </Select>
        </Col>
        <Col xs={24} sm={12} md={6}>
          <Text strong>Expected Move (%):</Text>
          <InputNumber
            style={{ width: "100%", marginTop: 8 }}
            min={1}
            max={15}
            step={1}
            value={expectedMove}
            onChange={setExpectedMove}
            formatter={(value) => `${value}%`}
            parser={(value) => value.replace("%", "")}
          />
        </Col>
        <Col xs={24} sm={12} md={6}>
          <Text strong>Expected Days:</Text>
          <InputNumber
            style={{ width: "100%", marginTop: 8 }}
            min={0}
            max={currentExpirationData?.trading_days_count || 10}
            value={expectedDays}
            onChange={setExpectedDays}
          />
        </Col>
        <Col xs={24} sm={12} md={6}>
          <Text strong>Future IV (%):</Text>
          <InputNumber
            style={{ width: "100%", marginTop: 8 }}
            min={1}
            max={200}
            step={1}
            value={futureIV}
            onChange={setFutureIV}
            formatter={(value) => `${value}%`}
            parser={(value) => value.replace("%", "")}
            placeholder={currentIV ? `${currentIV}%` : "IV"}
          />
        </Col>
      </Row>
    </Card>
  );
};

export default ControlsCard;
